module.exports = __webpack_public_path__ + "static/media/logo-inverted.3322b585.svg";